<script setup lang="ts">
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const fullname = userStore.fullname()
</script>
<template>
  <p>Welcome back, {{ fullname }}!</p>
</template>
